export default __webpack_public_path__ + "static/media/arrow.570b23a8.svg";